@use '@/styles/tokens' as *;

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  background: var(--surface-card);
  border: 1px solid var(--border-subtle);
  border-radius: 20px;
  box-shadow: var(--shadow-tab);
}

.icon {
  display: inline-flex;
  align-items: center;
  color: $color-accent1-700;
}

.label {
  font-size: 14px;
  color: var(--text-muted);
}

.value {
  font-family: #{$font-family-heading};
  font-size: 26px;
  font-weight: var(--font-weight-medium);
  letter-spacing: -0.02em;
  color: var(--text-primary);
}
